import type { SupplierRequestListObjectType, SupplierRequestType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import SupplierRequestsTableRow from './SupplierRequestsTableRow';

interface SupplierRequestsTableBodyProps {
    requests: SupplierRequestType[];
    canOps: boolean;
    onOpen: (requestId: number) => void;
    onClone: (row: SupplierRequestType) => void;
    onChanged: () => void;
    onSendEmail: (row: SupplierRequestType) => void;
    onFilterByObject: (object: SupplierRequestListObjectType) => void;
    showObject: boolean;
    showDate: boolean;
    showUser: boolean;
    showNote: boolean;
}

const SupplierRequestsTableBody = ({
    requests,
    canOps,
    onOpen,
    onClone,
    onChanged,
    onSendEmail,
    onFilterByObject,
    showObject,
    showDate,
    showUser,
    showNote,
}: SupplierRequestsTableBodyProps) => {
    const colSpan = 3
        + (showObject ? 1 : 0)
        + (showDate ? 1 : 0)
        + (showUser ? 1 : 0)
        + (showNote ? 1 : 0);

    if (!requests.length) {
        return (
            <tbody>
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <tbody>
            {requests.map((row) => (
                <SupplierRequestsTableRow
                    key={row.ID}
                    row={row}
                    canOps={canOps}
                    onOpen={onOpen}
                    onClone={onClone}
                    onChanged={onChanged}
                    onSendEmail={onSendEmail}
                    onFilterByObject={onFilterByObject}
                    showObject={showObject}
                    showDate={showDate}
                    showUser={showUser}
                    showNote={showNote}
                />
            ))}
        </tbody>
    );
};

export default SupplierRequestsTableBody;
